import { render, staticRenderFns } from "./PAYGPlansCard.vue?vue&type=template&id=bb4e2e12&"
import script from "./PAYGPlansCard.vue?vue&type=script&lang=js&"
export * from "./PAYGPlansCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports